export const buildStateRegionIndex = (states = []) => {
	const stateById = new Map();
	const regionById = new Map();
	const subregionById = new Map();

	(states || []).forEach((state) => {
		if (!state?.id) {
			return;
		}
		stateById.set(state.id, state);
		(state.regions || []).forEach((region) => {
			if (!region?.id) {
				return;
			}
			regionById.set(region.id, { ...region, stateId: state.id });
			(region.subregions || []).forEach((subregion) => {
				if (!subregion?.id) {
					return;
				}
				subregionById.set(subregion.id, {
					...subregion,
					stateId: state.id,
					regionId: region.id
				});
			});
		});
	});

	return { stateById, regionById, subregionById };
};

export const getStateRegionLabel = ({ stateId, regionId, subregionId }, index) => {
	if (!index) {
		return { stateName: "", regionName: "", subregionName: "" };
	}
	const stateName = stateId ? index.stateById.get(stateId)?.name || "" : "";
	const regionName = regionId ? index.regionById.get(regionId)?.name || "" : "";
	const subregionName = subregionId ? index.subregionById.get(subregionId)?.name || "" : "";
	return { stateName, regionName, subregionName };
};
